<script setup lang="ts">
import { useParticipants } from '@desktop/views/Relation/composables'
import ParticipantImportantStats from '@desktop/views/Relation/Sports/components/RelationView/ParticipantImportantStats.vue'

// composables
const { homeParticipant, awayParticipant } = useParticipants()
</script>

<template>
  <div class="flex gap-x-6.5">
    <ParticipantImportantStats
      v-if="homeParticipant"
      class="w-full"
      :participant="homeParticipant"
    />
    <slot />
    <ParticipantImportantStats
      v-if="awayParticipant"
      class="w-full"
      :participant="awayParticipant"
    />
  </div>
</template>
